import React from 'react'
import { Map, List } from 'immutable'
/* renders a heading based on the requested service (or view) for the offer groups
*/
const OfferGroupHeading = ({index, showHeading = true, offerGroup = Map(), view, children}) =>
{
  return (showHeading || children) ? <div style={{height:'50px'}}><h1 className="offer-group-heading">
      {showHeading && (view === 'book-a-flight' ?
        <span><i className="material-icons plane">&#xE195;</i>{index != null &&
        `${index + 1}: `}
        {offerGroup.get('requested', List())
            .map((s = Map()) =>
                `${s.get('from')} to ${s.get('to')}`)
            .join(', ')
        }</span>
      : view === 'get-a-room' ?
        <span><i className="material-icons hotel">&#xE53A;</i>{index != null &&
        `${index + 1}: `}
        {offerGroup.get('requested', List())
            .map((s = Map()) =>
                `${s.get('checkIn')} to ${s.get('checkOut')}`)
            .join(', ')
        }</span>
      : <span>`Request ${index + 1}`</span>
    )}
      {children}
      </h1></div> : null
}

// const FlightOfferGroupHeading = ({ legNo, offerGroup = Map() }) =>
//     // Creates a section heading in either of these two forms:
//     // Leg 1: JNB to CPT
//     // Group 1: JNB to CPT, CPT to LHR
//     <h1 className="offer-group-heading">
//         <i className="material-icons plane">&#xE195;</i>{legNo != null &&
//         `${legNo + 1}: `}
//         {offerGroup.get('requested', List())
//             .map((s = Map()) =>
//                 `${s.get('from')} to ${s.get('to')}`)
//             .join(', ')
//         }
//     </h1>

export default OfferGroupHeading



// WEBPACK FOOTER //
// ./src/ndc/offer/OfferGroupHeading.js